module.exports = __webpack_public_path__ + "static/media/games.ce39cff8.svg";